import axios from 'axios';

export const ORGANIZATION_API = axios.create({
    baseURL: process.env.REACT_APP_API_URL + 'organizations/'
});

